import { YEARS_IN_DECADE } from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";

export const getDecadeStart = (year: number): number =>
	Math.floor(year / YEARS_IN_DECADE) * YEARS_IN_DECADE;
